"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ProgressSpinner = _interopRequireDefault(require("./ProgressSpinner"));

var _LoadingSpinner = _interopRequireDefault(require("./LoadingSpinner"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Spinner = function Spinner(_ref) {
  var type = _ref.type,
      props = _objectWithoutProperties(_ref, ["type"]);

  return type === 'determinate' ? _react.default.createElement(_ProgressSpinner.default, props) : _react.default.createElement(_LoadingSpinner.default, props);
};

var _default = (0, _styledComponents.default)(Spinner).withConfig({
  componentId: "sc-1k789jy-0"
})(["margin:auto;"]);

exports.default = _default;